import React from 'react'
import { Line, LineChart as RechartsLineChart } from 'recharts'

import {
  axisIdFor,
  BASE_COLOR,
  TimeseriesChartFrame,
} from '../timeseries-chart'
import { LemonadeLineChartProps } from './line-chart.types'

/**
 * A timeseries line chart — one line per series, optionally split across two
 * y-axes. Everything but the lines themselves (axes, grid, tooltip, legend) comes
 * from `TimeseriesChartFrame`, shared with the area chart.
 */
export const LemonadeLineChart = ({
  series,
  ...frameProps
}: LemonadeLineChartProps) => (
  <TimeseriesChartFrame
    chart={RechartsLineChart}
    series={series}
    {...frameProps}
  >
    {series.map((s) => (
      <Line
        key={s.name}
        yAxisId={axisIdFor(s.axis)}
        type="monotone"
        dataKey={s.name}
        name={s.label ?? s.name}
        stroke={s.color ?? BASE_COLOR}
        strokeWidth={2}
        dot={false}
        activeDot={{ r: 4 }}
        connectNulls
        isAnimationActive
        animationDuration={800}
        animationEasing="ease-out"
      />
    ))}
  </TimeseriesChartFrame>
)
